<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_40",
      next: "P_42",
      topic: "Estás en: Taller ¿Qué es crédito? / ¡Quiero conocer el tipo de crédito ideal para mí!",
      reactivos: [
        {
          descripcion: "Tarjeta de crédito",
          src: "https://via.placeholder.com/140x100"
        },
        {
          descripcion: "Crédito automotriz",
          src: "https://via.placeholder.com/140x100"
        },
                {
          descripcion: "Crédito vía nómina",
          src: "https://via.placeholder.com/140x100"
        }
      ],
      selected: [],
      respuesta: "none",
      response: 0,
      correcta: 1,
      sent: false,
      feedback: false,
      dialog: false
    };
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.response);
    },

  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    },
    checkResult() {
      return {
        done: this.response != "none",
        clear: this.response == "none"
      };
    }
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg
              | ¿Qué crédito le sugieres a 
              b José 
              |  que tramite? 
            v-icon.pt-3.pr-3(color="accent") fas fa-bolt
            span.parrafoDestacado.accent--text
              b Información para decidir:
              |  Este tipo de crédito también ofrece seguros para el auto.  
            
            v-layout(align-center justify-center column v-for='(reactivo, index) in reactivos', :key='index')
              v-card.mx-0.my-3.pa-0(flat min-width=270 v-ripple @click="respuesta=index")
                v-layout.ma-0.pa-0
                  v-flex.ma-0.pa-0(xs6)
                    v-img.mx-0(v-if="reactivo.descripcion=='Tarjeta de crédito'" height='100', :src="require('@/assets/TCC-L7-Pagina3 C credito.png')")
                      v-icon.pa-2.green.check(v-if="respuesta==index" small color="white") fas fa-check
                    v-img.mx-0(v-if="reactivo.descripcion=='Crédito automotriz'" height='100', :src="require('@/assets/TCC-L7-Pagina5 B automotriz.png')")
                      v-icon.pa-2.green.check(v-if="respuesta==index" small color="white") fas fa-check
                    v-img.mx-0(v-if="reactivo.descripcion=='Crédito vía nómina'" height='100', :src="require('@/assets/TCC-L7-Pagina5 B nomina.png')")
                      v-icon.pa-2.green.check(v-if="respuesta==index" small color="white") fas fa-check
                  v-flex.ma-0.pa-0.grey.lighten-4(xs6)
                    v-card-text.mx-0.pa-2.pt-4.titulo24RegGrey {{reactivo.descripcion}}

            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                         v-card.pb-4
                          .pt-1.pr-2(v-if='sent && (respuesta==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Muy bien! 
                          .pt-1.pr-2(v-if='sent && (respuesta!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¿Estás seguro?
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-0.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | Con la tarjeta de crédito es posible que José se quede sin línea de crédito o que no sea suficiente para lo que quiere hacer.  
                              v-card-text.dialog_text
                                | El crédito automotriz es la mejor opción en este caso porque además de que es para esta necesidad en específico, ofrece tasas fijas o variables, plazos y seguros.
                            .pt-0.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                | El crédito automotriz es la mejor opción en este caso porque además de que es para esta necesidad en específico, ofrece tasas fijas o variables, plazos y seguros. 
                              v-card-text.dialog_text
                                | Con la tarjeta de crédito es posible que José se quede sin línea de crédito o que no sea suficiente para lo que quiere hacer. Lo mismo sucede con el crédito vía nómina.
                            .pt-0.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                | Con el crédito vía nómina es posible que el límite de crédito no sea suficiente para lo que José quiere hacer.  
                              v-card-text.dialog_text
                                | El crédito automotriz es la mejor opción en este caso porque además de que es para esta necesidad en específico, ofrece tasas fijas o variables, plazos y seguros. 

                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>

<style lang="stylus"> 

.check
  position absolute 
  bottom 0px
  right 0px


</style>